import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAccountSummary, fetchAccountTree, GetAccount } from "../../../store/thunks/accountSummary";
import { fetchAllDepartment, fetchEmails } from "../../../store/thunks/emails";
import { fetchNews } from "../../../store/thunks/news";
import { fetchAlerts } from "../../../store/thunks/alerts";
import { fetchAccountHistory, fetchAllOrders, fetchAllPositions, fetchAllSLTP } from "../../../store/thunks/orders";
import { fetchAmountUnit, fetchSymbolGroup, fetchAllSymbolParams } from "../../../store/thunks/symbolGroup";
import { fetchSymbols } from "../../../store/thunks/watchlist";
import LoadableButton from "../../button/LoadableButton";
import { getCookies } from "../../../services/Cookies";

const Datamanager = () => {
    const { loggedIn, userDetail } = useSelector(state => state.user);
    const { accountId } = useSelector(state => state.accountSummary);
    const dispatch = useDispatch();
    const token = getCookies('token')
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (loggedIn && userDetail?.id) {
            Promise.all([
                dispatch(fetchAllSymbolParams()),
                dispatch(fetchEmails()),
                dispatch(fetchNews()),
                dispatch(fetchSymbolGroup()),
                dispatch(fetchAmountUnit()),
                dispatch(fetchAllDepartment()),
                dispatch(fetchSymbols()),
            ]).then(() => setLoading(false)).catch(() => setLoading(false));
        }
    }, [userDetail?.id, token]);
    useEffect(() => {
        dispatch(fetchAccountTree())
    }, [])
    useEffect(() => {
        if (accountId) {
            setLoading(true);
            Promise.all([
                dispatch(fetchAlerts()),
                dispatch(fetchAllOrders(accountId)),
                dispatch(fetchAccountSummary(accountId)),
                dispatch(fetchAccountHistory(accountId)),
                dispatch(fetchAllPositions(accountId)),
                dispatch(fetchAllSLTP(accountId)),
            ]).then(() => setLoading(false)).catch(() => setLoading(false));
        }
    }, [accountId]);

    return loading ? <LoadableButton /> : null;
};

export default Datamanager;
